import decode from 'jwt-decode';


export default class JwtToken
{


    static getTokenPayload(token){
        const decoded = decode(token);
        return {
            "exp": decoded.exp, 
            "expired": (decoded.exp < Date.now() / 1000),
            "name": decoded.name,
            "scope": decoded.scope
        }
    }

    static isValidToken(token)
    {
        // this is lame. There are a lot of different tokens. We're describing the one we use specifically.
        var decoded = this.getTokenPayload(token);
        return ((decoded.exp) && (decoded.exp !== ""));
    }

    static isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. 
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return true;
        }
    }


}